const Humberger = (props: any) => {
  return (
    <svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M21 10.3335H3C2.59 10.3335 2.25 9.88016 2.25 9.3335C2.25 8.78683 2.59 8.3335 3 8.3335H21C21.41 8.3335 21.75 8.78683 21.75 9.3335C21.75 9.88016 21.41 10.3335 21 10.3335ZM21 17.0002H3C2.59 17.0002 2.25 16.5468 2.25 16.0002C2.25 15.4535 2.59 15.0002 3 15.0002H21C21.41 15.0002 21.75 15.4535 21.75 16.0002C21.75 16.5468 21.41 17.0002 21 17.0002ZM3 23.6668H21C21.41 23.6668 21.75 23.2135 21.75 22.6668C21.75 22.1202 21.41 21.6668 21 21.6668H3C2.59 21.6668 2.25 22.1202 2.25 22.6668C2.25 23.2135 2.59 23.6668 3 23.6668Z" fill="white"/>
    </svg>
  )
}

export default Humberger